import React, { useState, useEffect, useContext } from 'react';
import { AuthContext } from '../contexts/AuthContext';
import { API_URL } from './apiurl';
import PivotTableUI from 'react-pivottable/PivotTableUI';
import 'react-pivottable/pivottable.css';
import TableRenderers from 'react-pivottable/TableRenderers';
import PlotlyRenderers from 'react-pivottable/PlotlyRenderers';
import createPlotlyComponent from 'react-plotly.js/factory';
import Plot from 'react-plotly.js';

const PlotlyComponent = createPlotlyComponent(Plot);

export default function PivotReports() {
  const { auth } = useContext(AuthContext);

  // All entries
  const [allEntries, setAllEntries] = useState([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  // State für react-pivottable: PivotTableUI erwartet ein "pivotState"
  const [pivotState, setPivotState] = useState({
    data: [],
    rows: [],
    cols: [],
    aggregatorName: 'Sum',
    vals: ['hours'],
    rendererName: 'Table',
    plotlyOptions: {width: 800, height: 600},
    // etc.
  });

  // Laden der Einträge
  useEffect(() => {
    fetchEntries();
  }, []);

  const fetchEntries = async () => {
    try {
      setLoading(true);
      const resp = await fetch(`${API_URL}/entries`, {
        headers: { Authorization: `Bearer ${auth.token}` }
      });
      if (!resp.ok) {
        throw new Error('Fehler beim Laden der Einträge');
      }
      const data = await resp.json();
      // data = [ {date, type, subject, address, hours, hotelspeesen, verpflegungsMehraufwand, customerId, ...}, ...]
      setAllEntries(data);

      // Convert to an array-of-arrays or array-of-objects for pivot usage
      // Typically pivot() can handle array-of-objects directly.
      setPivotState(ps => ({
        ...ps,
        data: data // wir geben raw array-of-objects
      }));
    } catch (err) {
      console.error('PivotReports fetchEntries error:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  // Beispiel-Favoriten / "Gespeicherte Layouts"
  const [savedLayouts, setSavedLayouts] = useState([]);

  const handleSaveLayout = () => {
    // pivotState enthält die aktuelle Konfiguration
    // Man könnte es in localStorage oder DB ablegen
    const timestamp = new Date().toISOString();
    const layout = { name: `Favorit ${timestamp}`, state: pivotState };
    setSavedLayouts(prev => [...prev, layout]);
  };

  const handleLoadLayout = (layout) => {
    setPivotState(layout.state);
  };

  return (
    <div style={{ padding: '1rem' }}>
      <h2>Pivot Reports</h2>
      {error && <p style={{color:'red'}}>{error}</p>}
      {loading && <p>Daten werden geladen...</p>}

      <div style={{marginBottom:'1rem'}}>
        <button onClick={handleSaveLayout}>Aktuelle Ansicht speichern</button>
      </div>

      {/* Gespeicherte Layouts */}
      <div style={{marginBottom:'1rem'}}>
        <strong>Favoriten:</strong>
        {savedLayouts.map((fav, idx) => (
          <button key={idx} onClick={() => handleLoadLayout(fav)}>
            {fav.name}
          </button>
        ))}
      </div>

      {/* react-pivottable UI */}
      <PivotTableUI
        data={pivotState.data}
        onChange={s => setPivotState(s)}
        {...pivotState}
        renderers={Object.assign({}, TableRenderers, PlotlyRenderers)}
        // PlotlyRenderers to have charts
      />

      <p style={{marginTop:'1rem', color:'#666'}}>
        Hinweis: Reihen und Spalten per Drag & Drop anpassen, Aggregation und Renderer oben auswählen.
      </p>
    </div>
  );
}
